import produce from 'immer';
import { includes, reject } from 'lodash/fp';

import * as actions from './actions';

export const initialState = {
  newsletters: { data: null, loading: false, error: null },
  favorites: { data: null, loading: false, error: null },
  favoritesUpdated: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_NEWSLETTERS_REQUEST:
      draft.newsletters.loading = true;
      break;
    case actions.FETCH_NEWSLETTERS_SUCCESS:
      draft.newsletters.loading = false;
      draft.newsletters.data = action.payload.newsletters;
      break;
    case actions.FETCH_NEWSLETTERS_FAILURE:
      draft.newsletters.loading = false;
      draft.newsletters.error = action.payload.error;
      break;
    case actions.FETCH_FAVORITES_REQUEST:
      draft.favorites.loading = true;
      break;
    case actions.FETCH_FAVORITES_SUCCESS:
      draft.favorites.loading = false;
      draft.favorites.data = action.payload.favorites;
      break;
    case actions.FETCH_FAVORITES_FAILURE:
      draft.favorites.loading = false;
      draft.favorites.error = action.payload.error;
      break;
    case actions.UPDATE_FAVORITES_REQUEST:
      draft.favoritesUpdated.loading = true;
      break;
    case actions.UPDATE_FAVORITES_SUCCESS:
      draft.favoritesUpdated.loading = false;
      draft.favorites.data = includes(action.payload.value, draft.favorites.data)
        ? reject((favorite) => favorite === action.payload.value, draft.favorites.data)
        : [...draft.favorites.data, action.payload.value];
      break;
    case actions.UPDATE_FAVORITES_FAILURE:
      draft.favoritesUpdated.loading = false;
      draft.favoritesUpdated.error = action.payload.error;
      break;
    case actions.INIT_NEWSLETTERS:
      draft.newsletters = { data: null, loading: false, error: null };
      break;
    case actions.INIT_FAVORITES:
      draft.favorites = { data: null, loading: false, error: null };
      break;
    case actions.INIT_FAVORITES_UPDATED:
      draft.favoritesUpdated = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
